import { PrimaryButtonMTV2, RejectButtonMT } from '@/components/buttons/Buttons';
import { showError, showNotification } from '@/modules/notification/engine/notification.library';
import { RadioButton } from 'primereact/radiobutton';
import { useState } from 'react';
import bulkAddModule from './bulk-add.module.css';
import { axiosInstance } from '@/services/axios.service';
import { ENDPOINTS } from '@/constants/endpoints';
import { BulkProcessRequest, FileUploadControl, UploadEmployeesResponse } from '@/components/form-inputs/FileUpload4Form';
import { GenericResponse } from '@/common/common_utils';
import { People } from '../engine/People';
import { group } from 'console';

interface Props {
	groupId?: number;
	handleSelfClose: () => void;
}


const BulkAddPeopleForm = (props: Props) => {
	const [fileUrl, setFileUrl] = useState<string | undefined>();
	const [type, setType] = useState<string>('add-people');

	const actionOptions = [
		{
			id: 'add-people',
			title: 'Add these people to your account',
			description: 'Everyone added will be sent an email invite.',
		},
		{
			id: 'remove-people',
			title: 'Remove these people from your account',
			description: 'Everyone on the CSV will be deleted and unable to charge your credit card.',
		},
		{
			id: 'replace-people',
			title: 'Replace your list of people',
			description: 'Anyone not in the CSV will be deleted. New people will be added and receive invites. Existing people will remain active.',
		},
	];

	const sendInvites = async () => {
		await People.sendInvites(fileUrl!, type, props.groupId);
		props.handleSelfClose();
	}


	return (
		<div className="space-y-8">
			<div className="space-y-5 text-lg text-onSurfaceVariant font-normal">
				<p>
					Invite your team to join your company's account. For a
					faster activation experience,{' '}
					<span className="font-bold">add a phone number</span>. This
					allows Xpress to send the invitation directly through the
					app and/or by SMS if the phone number is associated with an
					Xpress account.
				</p>
				<p>
					Importing a CSV allows you to add and update people in bulk.
					To get started{' '}
					<button
						type="button"
						onClick={async () => {
							showNotification('Downloading template');
							const response = await axiosInstance.post(
								ENDPOINTS['/api/X4bEmployee/DownloadCsvTemplate'],
								{},
								{ responseType: 'blob' }
							);
							// Create a blob from the response
							const blob = new Blob([response.data], { type: 'text/csv' });
							// Create a link element
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'invite-employees.csv');
							document.body.appendChild(link);
							link.click();
							link.parentNode?.removeChild(link);
							window.URL.revokeObjectURL(url);
						}}
						className="text-tertiary underline"
					>
						Download the Template.
					</button>
				</p>
				<p>
					We'll add people to the group specified in the CSV. If you
					don't specify a group, well add them to General
				</p>
			</div>

			{/* <FileUploadInput
				name="demo[]"
				url="/api/upload"
				accept=".csv"
				maxFileSize={1000000}
				className="font-poppins w-full"
				onSelect={() => {
					setUploaded(true);
				}}
			/> */}
			{/* <FileUpload4Form
				control={form.control}
			/> */}
			<FileUploadControl
				value={fileUrl}
				onChange={setFileUrl}
				uploadEndpoint={ENDPOINTS['/api/X4bFile/UploadFile']}
				accept='.csv,text/csv'
				title='Drop files here to upload'
			></FileUploadControl>


			<div>
				{actionOptions.map((action) => (
					<div
						className={
							'flex items-center justify-between py-2 px-4 border-b border-outlineVariant cursor-pointer'
						}
						key={action.id}
					>
						<label
							htmlFor="anyLocation"
							className="text-onSurfaceVariant cursor-pointer text-base"
						>
							<p className="text-onSurface font-semibold text-lg">
								{action.title}
							</p>
							{action.description}
						</label>
						<RadioButton
							inputId={action.id}
							name={action.id}
							value={action.id}
							onChange={() => setType(action.id)}
							checked={type === action.id}
							pt={{
								box: {
									className: bulkAddModule.radioInput,
								},
								icon: {
									className: bulkAddModule.radioIcon,
								},
							}}
						/>
					</div>
				))}
			</div>
			<div className="flex justify-end gap-4">
				<RejectButtonMT
					id="cancel-exp-code"
					label="Cancel"
					onClick={props.handleSelfClose}
				/>
				<PrimaryButtonMTV2
					id="bulk-add-send"
					label="Send Invite"
					disabled={!fileUrl}
					onClick={sendInvites}
				/>
			</div>
		</div>
	);
};

export default BulkAddPeopleForm;
